var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowQuickFilter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M14.53 29.53a.75.75 0 0 0 0-1.06L2.81 16.75H31a.75.75 0 0 0 0-1.5H2.81L14.53 3.53a.75.75 0 0 0-1.06-1.06l-13 13a.75.75 0 0 0 0 1.06l13 13a.75.75 0 0 0 1.06 0",
  clipRule: "evenodd"
})));
export default SvgIconArrowQuickFilter;